import { render, staticRenderFns } from "./ManageSuppliersTabView.vue?vue&type=template&id=0279385b&"
import script from "./ManageSuppliersTabView.vue?vue&type=script&lang=js&"
export * from "./ManageSuppliersTabView.vue?vue&type=script&lang=js&"
import style0 from "./ManageSuppliersTabView.vue?vue&type=style&index=0&id=0279385b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports